import type { ReactElement } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";

// Prod pages arrive prerendered (scripts/inject-prerender.mjs) and hydrate;
// dev serves an empty #root and renders from scratch.
export function mount(page: ReactElement) {
  const root = document.getElementById("root")!;
  if (root.hasChildNodes()) {
    hydrateRoot(root, page);
  } else {
    createRoot(root).render(page);
  }
}
